import React from "react";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@material-ui/core";

const OptionsInput = (props) => {
    const {
        fieldConfig,
        label,
        value,
        handleChange,
        required,
        error,
    } = props;

    const isMultiple = Boolean(fieldConfig?.multiple);

    return (
        <FormControl
            error={error}
            style={{ width: "100%" }}
        >
            <InputLabel
                id={`label-${fieldConfig.name}`}
                required={required}
            >
                {label}
            </InputLabel>
            <Select
                labelId={`label-${fieldConfig.name}`}
                id={`select-${fieldConfig.name}`}
                multiple={isMultiple}
                value={isMultiple ? (value || []) : (value ?? "")}
                onChange={(e) => handleChange(e.target.value, fieldConfig.name)}
                margin={"none"}
            >
                {
                    (fieldConfig?.options || []).map((item) => (
                        <MenuItem
                            className={"whiteText"}
                            key={item.id || item.key}
                            value={item.id || item.key}
                        >
                            {item.value}
                        </MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    );
};

export default OptionsInput;